(() => {
  const script = document.querySelector('script[data-country-redirect]');
  if (!script || script.dataset.initialized || window.Shopify?.designMode) return;
  script.dataset.initialized = 'true';

  const current = new URL(window.location.href);
  let destination;
  try { destination = new URL(script.dataset.destination, current.origin); } catch { return; }
  if (destination.origin !== current.origin) return;
  if (destination.pathname.replace(/\/$/, '') === current.pathname.replace(/\/$/, '') &&
      [...destination.searchParams].every(([key, value]) => current.searchParams.get(key) === value)) return;
  const allowed = (script.dataset.allowed || '').toUpperCase().split(',').map(value => value.trim()).filter(value => /^[A-Z]{2}$/.test(value));
  if (!allowed.length) return;

  const cacheKey = 'throne_detected_country_v1';
  const valid = country => /^[A-Z]{2}$/.test(country?.handle || '') && !['XX', 'ZZ'].includes(country.handle);
  let detectedCountry = null;
  let detectedUntil = 0;

  // Refresh on each page. A country cached before a VPN/network change must not
  // deny a purchase; the session cache is only a convenience for the signup form.
  const detect = async () => {
    let timeout;
    try {
      const controller = new AbortController();
      timeout = setTimeout(() => controller.abort(), 2500);
      const root = script.dataset.root.replace(/\/?$/, '/');
      const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
        signal: controller.signal, credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      const data = response.ok ? await response.json() : null;
      if (controller.signal.aborted || !valid(data?.detected_values?.country)) return;
      detectedCountry = data.detected_values.country;
      detectedUntil = Date.now() + 30 * 60 * 1000;
      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ country: detectedCountry, expires: detectedUntil }));
      } catch {}
    } catch {
      // Failed or unavailable detection never changes commerce behavior.
    } finally {
      clearTimeout(timeout);
    }
  };
  void detect();

  // Only an already-known unsupported country intercepts purchase intent.
  // Pending/unknown/US results leave the original submit event completely intact.
  document.addEventListener('submit', event => {
    const form = event.target;
    const submitter = event.submitter;
    if (event.defaultPrevented || submitter?.disabled) return;
    if (!form.matches('form[data-country-redirect]') && !submitter?.matches('[data-country-redirect]')) return;
    if (!detectedCountry || detectedUntil <= Date.now() || allowed.includes(detectedCountry.handle)) return;
    const target = new URL(destination);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    }
    target.searchParams.set('launch_country', detectedCountry.handle);
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(target.href);
  }, true);
})();
